// Generated with tools/create-component.js
import React, { useEffect } from "react";
import { Carousel, CarouselTypes, CmsContent, Container, Image } from "components";
import { BackgroundColourEnum } from "utils";
import { SliderGalleryQueryFragment } from "codegen";
import "./SliderGallery.scss";
import AOS from "aos";
import "aos/dist/aos.css";

interface SliderGalleryProps {
  data: SliderGalleryQueryFragment;
}

export const SliderGallery: React.FC<SliderGalleryProps> = ({
  data: { description, gallery, backgroundColour },
}): JSX.Element => {
  const swiperSettings: CarouselTypes = {
    slidesPerView: 1.3,
    centeredSlides: true,
    spaceBetween: 10,
    grabCursor: false,
    pagination: false,
    navigation: true,
    loop: true,
    breakpoints: {
      600: {
        slidesPerView: 2.3,
        spaceBetween: 10,
      },
      1340: {
        slidesPerView: 2.15,
      },
    },
  };

  const containerWidth = "layout--full";

  return (
    <Container
      className="slider-gallery"
      backgroundColour={BackgroundColourEnum[backgroundColour]}
      containerWidth={containerWidth}
    >
      {description && (
        <div className="slider-gallery__description" data-aos="fade-in">
          <CmsContent content={description} />
        </div>
      )}
      {gallery && (
        <Carousel swiperSettings={swiperSettings}>
          {(gallery as string[]) &&
            gallery.map((image, index) => {
              return <Image className="image" src={image} key={index} />;
            })}
        </Carousel>
      )}
    </Container>
  );
};
